import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Review } from 'functions/src/types/firestore/Game/Review';
import { AvatarNext } from '../AvatarNext';

export type ReviewAvatarProps = Review<Date>['author'];

function stringToColor(string: string) {
  let hash = 0;
  let i;

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }

  return color;
}

function stringAvatar(name: string) {
  const uppercaseName = name.toUpperCase();
  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: `${uppercaseName[0]}${uppercaseName[1]}`,
  };
}

export function ReviewAvatar({
  imgUrl,
  reviewsCount,
  username,
}: ReviewAvatarProps) {
  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
    >
      {!imgUrl ? (
        <AvatarNext
          {...stringAvatar(username as string)}
          sx={{
            width: '76px',
            height: '76px',
            border: `1.5px solid rgba(255, 255, 255, 0.75)`,
          }}
          alt={username}
        />
      ) : (
        <AvatarNext
          sx={{
            width: '76px',
            height: '76px',
            border: `1.5px solid rgba(255, 255, 255, 0.75)`,
          }}
          src={imgUrl}
          alt={username}
        />
      )}

      <Typography
        sx={{
          marginTop: '4px',
          color: (theme) => theme.palette.text.secondary,
        }}
        variant="caption"
      >
        {reviewsCount} {reviewsCount === 1 ? 'REVIEW' : 'REVIEWS'}
      </Typography>
    </Box>
  );
}
